import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=0efa090c&"
import script from "./VTag.vue?vue&type=script&lang=ts&"
export * from "./VTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports